/* tslint:disable */
/* eslint-disable */
/**
 * RakuLogi API
 * RakuLogi の API ドキュメント
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  RequestGetShippingSourceInformationRequest,
  RequestUpsertShippingSourceInformationRequest,
  ResponseGetShippingSourceInformationResponse,
} from '../models/index';
import {
    RequestGetShippingSourceInformationRequestFromJSON,
    RequestGetShippingSourceInformationRequestToJSON,
    RequestUpsertShippingSourceInformationRequestFromJSON,
    RequestUpsertShippingSourceInformationRequestToJSON,
    ResponseGetShippingSourceInformationResponseFromJSON,
    ResponseGetShippingSourceInformationResponseToJSON,
} from '../models/index';

export interface ShippingSourceInformationGetShippingSourceInformationPostRequest {
    req: RequestGetShippingSourceInformationRequest;
}

export interface ShippingSourceInformationUpsertShippingSourceInformationPostRequest {
    req: RequestUpsertShippingSourceInformationRequest;
}

/**
 * 
 */
export class ShippingSourceInformationApi extends runtime.BaseAPI {

    /**
     * 配送元情報を取得
     * 配送元情報を取得
     */
    async shippingSourceInformationGetShippingSourceInformationPostRaw(requestParameters: ShippingSourceInformationGetShippingSourceInformationPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseGetShippingSourceInformationResponse>> {
        if (requestParameters['req'] == null) {
            throw new runtime.RequiredError(
                'req',
                'Required parameter "req" was null or undefined when calling shippingSourceInformationGetShippingSourceInformationPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/shippingSourceInformation/getShippingSourceInformation`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RequestGetShippingSourceInformationRequestToJSON(requestParameters['req']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseGetShippingSourceInformationResponseFromJSON(jsonValue));
    }

    /**
     * 配送元情報を取得
     * 配送元情報を取得
     */
    async shippingSourceInformationGetShippingSourceInformationPost(requestParameters: ShippingSourceInformationGetShippingSourceInformationPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseGetShippingSourceInformationResponse> {
        const response = await this.shippingSourceInformationGetShippingSourceInformationPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 配送元情報登録／更新
     * 配送元情報登録／更新
     */
    async shippingSourceInformationUpsertShippingSourceInformationPostRaw(requestParameters: ShippingSourceInformationUpsertShippingSourceInformationPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>> {
        if (requestParameters['req'] == null) {
            throw new runtime.RequiredError(
                'req',
                'Required parameter "req" was null or undefined when calling shippingSourceInformationUpsertShippingSourceInformationPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/shippingSourceInformation/upsertShippingSourceInformation`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RequestUpsertShippingSourceInformationRequestToJSON(requestParameters['req']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<boolean>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * 配送元情報登録／更新
     * 配送元情報登録／更新
     */
    async shippingSourceInformationUpsertShippingSourceInformationPost(requestParameters: ShippingSourceInformationUpsertShippingSourceInformationPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.shippingSourceInformationUpsertShippingSourceInformationPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
